import { FC } from 'react'

import {
  Badge as MantineBadge,
  BadgeProps as MantineBadgeProps,
} from '@mantine/core'
import styled from 'styled-components'

const StyledBadge = styled(MantineBadge)`
  /* Здесь можно добавить кастомные стили */
`

export type BadgeProps = MantineBadgeProps

export const Badge: FC<BadgeProps> = (props) => {
  return <StyledBadge {...props} />
}
